import React, {useContext, useMemo} from "react";
import PropTypes from "prop-types";
import {MFade} from "components/Shared";
import {MDropzoneContext} from "components/Shared/MDropzone/contexts";

const ActiveArea = ({children}) => {
  const {
    getRootProps,
    getInputProps,
    isDragAccept,
    isDragActive,
  } = useContext(MDropzoneContext);
  const className = useMemo(
    () => `ActiveArea-DropzoneRoot${(isDragAccept || isDragActive) ? " ActiveArea-DropzoneRoot-active" : ""}`,
    [isDragAccept, isDragActive]
  );
  return (
    <div className={"ActiveArea-Root"}>
      <MFade in>
        <div {...{className, ...getRootProps()}}>
          <input {...getInputProps()}/>
          {children}
        </div>
      </MFade>
    </div>
  );
};

ActiveArea.defaultProps = {
  children: <div/>,
};

ActiveArea.propTypes = {
  children: PropTypes.node,
};

export default ActiveArea;